import {
  IDataQueueResponse,
  ISearchQueuePagedResponse,
  IWorkflowItemStep,
  SearchQueuePagedRequest,
} from "../../../../common/sharedTypes";
import Api from "../../../../services/Api";
import { ApiResponse } from "apisauce";
import { DataTranscriberValidationQueueActionTypes } from "../types";
import { toast } from "react-toastify";
import * as urls from "../../../shared/urls";

export const getPaperReports = async (
  url: string,
  request: SearchQueuePagedRequest
): Promise<ApiResponse<ISearchQueuePagedResponse>> => {
  return await Api.post(url, request);
};

export const searchPaperReportsPaged = (url: string, request: SearchQueuePagedRequest) => {
  return async (dispatch) => {
    try {
      dispatch(setLoadingWorkflowSteps(true));
      await getPaperReports(url, request).then(
        (response: ApiResponse<ISearchQueuePagedResponse>) => {
          dispatch(setPaperReports(response.data.workflowItems));
          dispatch(setTotalWorkflowSteps(response.data.totalResults));
        }
      );
    } catch (ex) {
      console.log(ex);
    } finally {
      dispatch(setLoadingWorkflowSteps(false));
    }
  };
};

export const searchPaperReports = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<any>) => {
        dispatch(setPaperReports(response.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const setLoadingWorkflowSteps = (value: boolean) => {
  return {
    type: DataTranscriberValidationQueueActionTypes.LOADING_WORKFLOW_STEPS,
    value: value,
  };
};

export const setTotalWorkflowSteps = (value: number) => {
  return {
    type: DataTranscriberValidationQueueActionTypes.TOTAL_WORKFLOW_STEPS,
    value: value,
  };
};

export const setPaperReports = (workflowItems: IDataQueueResponse[]) => {
  return {
    type: DataTranscriberValidationQueueActionTypes.SEARCH_REPORTS,
    value: workflowItems,
  };
};

export const searchReportData = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<any>) => {
        dispatch(setReportData(response.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};
export const setReportData = (notifications: IWorkflowItemStep[]) => {
  return {
    type: DataTranscriberValidationQueueActionTypes.GET_REPORT_DATA,
    value: notifications,
  };
};

export const openReport = (workflowItemStepId: number) => {
  return async (dispatch) => {
    try {
      await Api.post(urls.GET_WORKFLOW_ITEM_STEP, {
        workflowStepItemId: workflowItemStepId,
      }).then((result: ApiResponse<any>) => {
        dispatch(view(result.data));
        if (result.data == null) {
          toast.error("Error opening");
          return Promise.reject(result.data);
        }
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const view = (workflowItemStep: IWorkflowItemStep) => {
  return {
    type: DataTranscriberValidationQueueActionTypes.OPEN_REPORT,
    value: workflowItemStep,
  };
};

export const assignAndOpen = (url, stepItemId, assignToId) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItemId,
        assignToUserId: assignToId,
      }).then((result: ApiResponse<any>) => {
        dispatch(reduceAssignAndOpen(result.data));
        if (result.data == null) {
          toast.error("Report already assigned");
          return Promise.reject(result.data);
        }
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const reduceAssignAndOpen = (itemStep: IWorkflowItemStep) => {
  return {
    type: DataTranscriberValidationQueueActionTypes.ASSIGN_AND_OPEN_REPORT,
    value: itemStep,
  };
};

export const unAssign = (url, stepItem) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItem.id,
      }).then((result: ApiResponse<any>) => {
        dispatch(reduceUnAssign(result.data));
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceUnAssign = (itemStep: IWorkflowItemStep) => {
  return {
    type: DataTranscriberValidationQueueActionTypes.UNASSIGN,
    value: itemStep,
  };
};

export const completeDataTranscriberValidation =
  (
    url: string,
    itemStep: IWorkflowItemStep,
    data: any,
    moveToNextWorkflow: boolean,
    assignNext: boolean
  ) =>
  (dispatch) =>
    new Promise(function (resolve, reject) {
      Api.post(url, {
        workflowItemStepId: itemStep.id,
        data: JSON.stringify(data),
        moveToNextWorkflow: moveToNextWorkflow,
        assignNext: assignNext,
      })
        .then((result: ApiResponse<any>) => {
          if (result.ok && result.data) {
            dispatch(reduceComplete(result.data));
          }
          resolve(result);
        })
        .catch((ex) => {
          console.warn(ex);
          reject(ex);
        });
    });

export const reduceComplete = (nextItemStep: IWorkflowItemStep) => {
  return {
    type: DataTranscriberValidationQueueActionTypes.COMPLETE_DATA_ENTRY,
    value: nextItemStep,
  };
};

export const saveDataTranscriberValidation = (
  url: string,
  itemStep: IWorkflowItemStep,
  data: any
) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowItemStepId: itemStep.id,
        data: JSON.stringify(data),
      }).then((result: ApiResponse<any>) => {
        if (result.data) {
          dispatch(reduceComplete(result.data));
        }
        return Promise.resolve();
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceSave = (updatedItemStep: IWorkflowItemStep) => {
  return {
    type: DataTranscriberValidationQueueActionTypes.SAVE_DATA_TRANSCRIBE_VALIDATION,
    value: updatedItemStep,
  };
};
